<template>
	<div>
		<template v-if="type == 'all'">
			<el-pagination ref="Pagination" :disabled="paginationFalg" :current-page="pageNo"
				:page-sizes="[5,10,15,20,50,100,200,500]" :page-size="pageSize" background :layout="layout"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total">
				<!--   -->
			</el-pagination>
		</template>
		<template v-if="type == 'total'">
			<el-pagination ref="Pagination" :disabled="paginationFalg" @size-change="handleSizeChange"
				:page-sizes="[5,10,15,20,50,100,200,500]" @current-change="handleCurrentChange" :page-size="pageSize"
				layout="total, prev, pager, next" :total="total">
			</el-pagination>
		</template>
		<template v-if="type == 'allColor'">
			<div class="totalColor">
				<!-- <el-pagination ref="Pagination" :disabled="paginationFalg" :page-size="pageSize" background layout="total,sizes, prev, pager, next , jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[5,10,15,20]" :total="total">
        </el-pagination> -->
				<el-pagination ref="Pagination" :pager-count="5" :disabled="paginationFalg" :layout="layout"
					:page-sizes="[5,10,15,20,50,100,200,500]" :current-page="pageNo" :page-size="pageSize" background
					@size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total">
					<!-- :page-sizes="[5,10,15,20]"  -->
				</el-pagination>
			</div>
		</template>
		<template v-if="type == 'all10'">
			<el-pagination ref="Pagination" :disabled="paginationFalg" :page-sizes="[5,10,15,20,50,100,200,500]"
				:current-page="pageNo" :page-size="pageSizes" background layout="total, prev, pager, next "
				@size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total">
				<!-- :page-sizes="[5,10,15,20]"  -->
			</el-pagination>
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			total: {
				type: Number,
				default: 0
			},
			pageSize: {
				type: Number,
				default: 20
			},
			currentPage2: {
				type: Number,
				default: 1
			},
			type: {
				type: String,
				default: 'all'
			},
			paginationFalg: {
				type: Boolean,
				default: false
			},
			layout: {
				type: String,
				default: "total, sizes, prev, pager, next, jumper"
			},
			pageNo: {
				type: Number,
				default: 1
			}
		},
		data: function() {
			return {
				//pageNo: 1,
				pageSizes: 10,
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			handleSizeChange(val) {
				this.$emit("handleSizeChange", val)
				// //console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.$emit("handleCurrentChange", val)
				// //console.log(`当前页: ${val}`);
			}
		}
	}
</script>
<style>
	li.el-select-dropdown__item.selected {
		color: #e71d43 !important;
	}
</style>
<style lang="less" scoped>
	::v-deep {
		.el-input.el-input--mini.el-input--suffix .el-input__inner {
			width: 100px;
			height: 32px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.el-input.el-pagination__editor.is-in-pagination .el-input__inner {
			width: 50px;
			height: 30px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.btn-next {
			width: 32px;
			height: 31px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.btn-prev {
			width: 32px;
			height: 31px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.el-pager .number {
			min-width: 32px;
			max-width: 42px;
			height: 31px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.el-pagination.is-background .el-pager li:not(.disabled) {
			background-color: #fff; // 进行修改未选中背景和字体
			border: 1px solid #d9d9d9;
			// color: #fff;
			max-width: 80px;
		}

		.el-pagination.is-background .el-pager li:not(.disabled):hover {
			border: 1px solid #e71d43;
			color: #e71d43;
			border-radius: 2px;
		}

		.el-pagination.is-background .el-pager li:not(.disabled).active {
			// background-color: green;   // 进行修改选中项背景和字体
			border: 1px solid #e71d43;
			color: #e71d43;
			border-radius: 2px;
		}

		.el-pager li.active {
			color: #e71d43;
			cursor: default;
		}

		.el-pager li:hover {
			color: #e71d43;
		}

		.el-pagination button:hover {
			color: #e71d43;
		}

		.el-select .el-input__inner:focus {
			border-color: #e71d43;
		}

		.el-select .el-input__inner.active {
			// background-color: green;   // 进行修改选中项背景和字体
			border: 1px solid #e71d43;
		}

		.el-select .el-input__inner:hover {
			// background-color: green;   // 进行修改选中项背景和字体
			border: 1px solid #e71d43;
		}

		.el-pagination__editor.el-input .el-input__inner:hover {
			border: 1px solid #e71d43;
		}

		.el-pagination__editor.el-input .el-input__inner:active {
			border: 1px solid #e71d43;
		}

		.el-pagination__editor.el-input .el-input__inner:focus {
			border: 1px solid #e71d43;
		}

		.totalColor .el-select .el-input__inner:focus {
			background-color: #e71d43;
		}

		.totalColor .el-select .el-input__inner.active {
			// background-color: green;   // 进行修改选中项背景和字体
			background-color: #e71d43;
			color: #fff;
		}

		.totalColor .el-select .el-input__inner:hover {
			// background-color: green;   // 进行修改选中项背景和字体
			background-color: #e71d43;
			color: #fff;
		}

		.totalColor .el-pagination.is-background .el-pager li:not(.disabled):hover {
			background-color: #e71d43;
			color: #fff;
			border-radius: 2px;
		}

		.totalColor .el-pagination.is-background .el-pager li:not(.disabled).active {
			// background-color: green;   // 进行修改选中项背景和字体
			background-color: #e71d43;
			color: #ffffff;
			border-radius: 2px;
		}

		.totalColor .btn-next {
			width: 32px;
			height: 29px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.totalColor .btn-prev {
			width: 32px;
			height: 29px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.totalColor .el-input.el-pagination__editor.is-in-pagination .el-input__inner {
			width: 50px;
			height: 32px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
		}

		.totalColor .el-input.el-input--mini.el-input--suffix .el-input__inner {
			width: 100px;
			height: 32px;
			background: #ffffff;
			border-radius: 2px;
			border: 1px solid #d9d9d9;
			color: #333333;
			font-size: 13px;
		}

		.totalColor .el-pagination__jump {
			color: #333333;
			font-size: 13px;
		}

		.totalColor .el-pagination__total {
			color: #333333;
			font-size: 13px;
		}
	}
</style>